<script>

import VueCharts from 'vue-chartjs'
import { Bar, mixins } from 'vue-chartjs'

export default {
  extends: Bar,
  props: ['maxScore'],
  mixins: [mixins.reactiveProp],
  mounted () {
    this.renderChart(this.chartData, {
        responsive: true,
        maintainAspectRatio: true,
        devicePixelRatio: 4,
        scales: {
            xAxes: [{
                gridLines: {
                    display: true
                },
                scaleLabel: {
                    display: true,
                    labelString: 'Task'
                }
            }],
            yAxes: [{
                gridLines: {
                    display: true
                },
                ticks: {
                    min: 0,
                    max: this.maxScore >= 5 ? 7 : this.maxScore + 1,
                    stepSize: 1,
                },
                scaleLabel: {
                    display: true,
                    labelString: 'Recalled'
                }
            }]
        },
        title: {
            display: true,
            text: 'Words recalled for each task'
        },
        legend: {
            display: false,
            position: 'bottom'
        }
    })
  }
}

</script>